import { useTranslation } from 'next-i18next'

import appConfig from '~/config/app'
import { useAppDispatch } from '~/redux/hooks'
import { getVisibleTabData } from '~/settings-scenario/const/tabData.const'
import { Tab } from '~/settings-scenario/types'
import useCurrentUser from '~/hooks/useCurrentUser'
import { userHasCustomerPortal, userHasSubscription } from '~/redux/utils/subscription'
import { setTabActionCreator } from '~/settings-scenario/redux/settings.slice'
import { StripeCustomerPortal } from '~/settings-scenario/components/StripeCustomerPortal'
import { TabItem } from '~/settings-scenario/components/TabItem'
import useCurrentFamily from '~/familyAccount/hooks/useCurrentFamily'
import { ShowUpgradeTab } from '~/settings-scenario/components/ShowUpgradeTab'
import { useCanChangePassword } from '~/settings-scenario/hooks/useCanChangePassword'

export function TabList(): React.ReactElement {
  const { t } = useTranslation('settings')
  const dispatch = useAppDispatch()
  const user = useCurrentUser()
  const { isFamilyAdmin, isFamilyMember } = useCurrentFamily()
  const showCustomerPortal = userHasCustomerPortal(user)
  const hasSubscription = userHasSubscription(user)
  // No commerce in the school platform. Needed on top of userHasCustomerPortal returning false, because
  // the `isFamilyAdmin` arm alone would still show the manage tab, and the upgrade tab keys off
  // userHasSubscription rather than the portal.
  const showMangeSubscription =
    !appConfig.isSchoolPlatform && (isFamilyAdmin || (!isFamilyMember && showCustomerPortal))
  const showUpgradeSubscription = !appConfig.isSchoolPlatform && !isFamilyMember && !isFamilyAdmin && hasSubscription
  const canChangePassword = useCanChangePassword()
  const visibleTabs = getVisibleTabData(canChangePassword, appConfig.isSchoolPlatform)

  const onTabChange = (tab: Tab): void => {
    dispatch(setTabActionCreator(tab))
    window.scrollTo(0, 0)
  }

  return (
    <ul className="font-medium my-2 space-y-8 md:space-y-12 flex-0-0 md:flex-none">
      {visibleTabs.map((elem) => {
        const name = t(`completeProfileTabNames.${elem.name}`)
        return <TabItem key={elem.tab} name={name} onTabChange={onTabChange} tab={elem.tab} />
      })}

      {showMangeSubscription && <StripeCustomerPortal />}
      {showUpgradeSubscription && <ShowUpgradeTab />}
    </ul>
  )
}
